// extracted by mini-css-extract-plugin
export default {"helpIconNoLabel":"helpIconNoLabel---YPihy","helpIcon":"helpIcon---v9iaR"};